import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import store from "./redux/store";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CAPTCHA_ENTERPRISE_SITE_KEY_V3} useRecaptchaNet={true}>
        <App />
      </GoogleReCaptchaProvider>
    </React.StrictMode>
  </Provider>
);
